import React, { useEffect, useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
// import { Map, Marker, Popup, TileLayer, useMapEvent, useMapEvents } from 'react-leaflet';
import { CircleMarker, Map, Marker, Popup, TileLayer } from 'react-leaflet';
import "leaflet/dist/leaflet.css";
import L from 'leaflet';

import location from './js-files'
import myLocation from './assets/my_location.png';
import pointerLocation from './assets/location.svg';
import Button from './children/Button';

const pointerIcon = new L.Icon({
  iconUrl: pointerLocation,
  iconRetinaUrl: pointerLocation,
  iconAnchor: [5, 46],
  popupAnchor: [10, -44],
  iconSize: [30, 55]
});

const MapBox = ({
  locationValue = location.init(51.3890, 35.6892, 12),
  handleChangeLocation,
  handleFindMyLocation,
  className,
  initZoom = 12,
  width = "100%",
  height = "25rem",
  addressId }) => {

  const [hasLocation, setHasLocation] = useState(false);
  const [viewport, setViewport] = useState({});
  const [lat, setLat] = useState(locationValue.lat);
  const [lng, setLng] = useState(locationValue.lng);
  const [zoom, setZoom] = useState(locationValue.zoom);
  const [userLocation, setUserLocation] = useState(locationValue.toArray());
  const mapRef = useRef(null);
  // const [userLocation, setUserLocation] = useState(!loadLat ? [lng, lat] : [loadLng, loadLat]);

  useEffect(() => {
    setUserLocation(locationValue.toArray());
    setZoom(locationValue.zoom);
    // console.log("useeffect", LocationValue);
    // console.log(LocationValue);

  }, [locationValue]);


  const handleOnMove = (e) => {
    const [newLat, newLng] = e.center;
    setLat(newLat);
    setLng(newLng);
    setZoom(e.zoom);
    setUserLocation([newLat, newLng]);
    // handleMoveOnMap(newLat, newLng, zoom);
  }

  const handleOnMoveEnd = (e) => {
    const [newLat, newLng] = e.center;
    handleMoveOnMap(newLat, newLng, e.zoom);
  }

  const handleClick = (e) => {
    const map = mapRef.current;
    if (map != null) {
      map.leafletElement.locate();
    }
  };

  const handleLocationFound = (e) => {
    // console.log("location found", e);
    setHasLocation(true);
    const { lat, lng } = e.latlng;
    setUserLocation([lng, lat]);
    handleFindMyLocation(lat, lng, 18);
  }

  const handleErrorLocation = (error) => {
    // console.log("on error location");
    console.log(error);
    alert(error.message);
  }

  const handleMoveOnMap = (newLat, newLng, newZoom) => {
    handleChangeLocation({
      lat: newLat,
      lng: newLng,
      zoom: newZoom
    });
  };


  const marker =
    <Fragment>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={userLocation} icon={pointerIcon}>
        <Popup>You are here</Popup>
      </Marker>
    </Fragment>
    ;


  return (
    <div className={className} style={{ width: width, height: height, overflow: "auto", position: "relative" }}>
      <Map
        style={{ height: '100%' }}
        center={userLocation}
        zoom={zoom}
        ref={mapRef}
        onViewportChange={handleOnMove}
        onViewportChanged={handleOnMoveEnd}
        onlocationfound={handleLocationFound}
        onlocationerror={handleErrorLocation}
      // onclick={handleClick}
      >
        {marker}
      </Map>

      <Button
        onClick={handleClick}
        imgSrc={myLocation}
        style={{ position: 'absolute', bottom: '2.5rem', right: "2.5rem", zIndex: '1000', width: "3rem", height: "3rem", padding: "0.5rem", backgroundColor: "#fff", borderRadius: "0.5rem", border: "1px solid #676767" }}
      />
    </div>
  );
};

Map.propTypes = {
  loadLng: PropTypes.number,
  loadLat: PropTypes.number,
  initZoom: PropTypes.number,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}

export default MapBox;























 // const MyComponent = () => {
  //   const map = useMapEvents({
  //     click: () => {
  //       map.locate();
  //       console.log('click and start map click activated');
  //     },
  //     locationfound: (location) => {
  //       console.log('location found:', location)
  //     },
  //     locationerror: (error) => {
  //       console.log('location found:', error);

  //     }
  //   })
  //   return null;

  //   //or

  //   // const map = useMapEvent('click', (e) => {
  //   //   console.log(e);
  //   //   // map.setCenter();
  //   // })
  //   // return null;
  // };

  //برای ست کردن نشان گر نقشه بر روی لوکیشن فعلی کاربر
  // const LocationMarker = () => {
  //   const map = useMapEvents({
  //     click() {
  //       map.locate()
  //     },
  //     locationfound(e) {
  //       setUserLocation(e.latlng);
  //       map.flyTo(e.latlng, map.getZoom());
  //     },
  //   });

  //   return userLocation === null ? null : (
  //     <Marker
  //       position={userLocation}
  //       draggable={false}
  //     >
  //       <Popup>شما در اینجا هستید.</Popup>
  //     </Marker>
  //   )
  // };